import { NgModule } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  GuardResult,
  MaybeAsync,
  RouterModule,
  RouterStateSnapshot,
  Routes,
} from '@angular/router';
import { AuthenticationGuard } from './core/guards/auth-guards.service';
import { AssistanceComponent } from './modules/private/pages/assistance/assistance.component';
import { PrivateComponent } from './modules/private/private.component';
import { PublicComponent } from './modules/public/public.component';
import { EditorComponent } from './shared/components/editor/editor.component';
import { MeetingsComponent } from './modules/private/pages/meetings/meetings.component';
import { DetailsComponent } from './modules/private/pages/meetings/details/details.component';
import { FichePointComponent } from './modules/private/pages/meetings/details/fiche-point/fiche-point.component';
import { PointsComponent } from './modules/private/pages/points/points.component';
import { CreateComponent } from './modules/private/pages/meetings/create/create.component';
import { PointTablesComponent } from './modules/private/pages/points/tables/tables.component';
import { InfosMeetingComponent } from './shared/components/infos-meeting/infos-meeting.component';
import { IntroConclusionPointComponent } from './shared/components/intro-conclusion-point/intro-conclusion-point.component';
import { PointSearchDisplayComponent } from './modules/private/pages/points/search-display/search-display.component';
import { DetailsPointsComponent } from './modules/private/pages/points/details/details.component';
import { Import3PComponent } from './modules/private/pages/points/import3-p/import3-p.component';
import { ConfirmDeactivateGuard } from './core/guards/confirm-deactivate.guard';
import { ConfirmDeactivateScanGuard } from './core/guards/confirm-deactivate-scan.guard';
import { HomeScanComponent } from './shared/components/scanV2/home/home-scan.component';
import { DetailScanComponent } from './shared/components/scanV2/details/detail-scan.component';
import { InfosComponent } from './modules/private/pages/points/create-update/component/infos/infos.component';
import { CallbackComponent } from '@devinforius/i-sso';
import { DevComponent } from './core/components/dev/dev.component';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import { PointFormComponent } from './modules/private/pages/points/point-form/point-form.component';
const devGuard: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => MaybeAsync<GuardResult> = (
  route,
  state
) => of(environment.devMode);

const routes: Routes = [
  {
    path: 'public',
    component: PublicComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'private',
    component: PrivateComponent,
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: '',
        component: PointsComponent,
      },
      {
        path: 'meetings',
        component: MeetingsComponent,
      },
      // {
      //   path:'meetings/:id/infos',component:InfosMeetingComponent,
      // },
      {
        path: 'meetings/:id/infos',
        component: InfosMeetingComponent,
      },
      {
        path: 'meetings/create',
        component: CreateComponent,
      },
      {
        path: 'meetings/detail/:id/:type',
        component: IntroConclusionPointComponent,
        data: { sidebarSmall: true },
      },
      {
        path: 'meetings/details/:id',
        component: DetailsComponent,
        data: { sidebarSmall: true },
        children: [
          {
            path: 'point/:pointID',
            component: FichePointComponent,
            canDeactivate: [ConfirmDeactivateGuard],
          },
          {
            path: 'infos',
            component: InfosMeetingComponent,
          },

          {
            path: ':type',
            component: IntroConclusionPointComponent,
          },
        ],
      },
      {
        path: 'points',
        component: PointsComponent,
        data: { sidebarSmall: true },
        children: [
          {
            path: 'searchTab/:title',
            component: PointTablesComponent,
          },
          {
            path: 'search/:search',
            component: PointTablesComponent,
          },
        ],
      },
      {
        path: 'points/display/searchTab/:title',
        component: PointSearchDisplayComponent,
        children: [{ path: 'point/:pointID', component: FichePointComponent, canDeactivate: [ConfirmDeactivateGuard] }],
      },
      {
        path: 'points/display/search/:search',
        component: PointSearchDisplayComponent,
        children: [{ path: 'point/:pointID', component: FichePointComponent, canDeactivate: [ConfirmDeactivateGuard] }],
      },
      {
        path: 'points/create',
        // component: CreatePointComponent,
        component: InfosComponent,
      },
      {
        path: 'points/form',
        component: PointFormComponent,
      },
      {
        path: 'points/import3P',
        component: Import3PComponent,
      },
      {
        path: 'points/create-from-icourrier',
        // component: CreatePointFromIcourrierComponent,
        component: InfosComponent,
      },
      {
        path: 'points/update/:id',
        // component: CreatePointComponent,
        component: InfosComponent,
      },
      {
        path: 'points/duplicate/:id',
        // component: CreatePointComponent,
        component: InfosComponent,
      },
      {
        path: 'points/detail/:pointID',
        component: DetailsPointsComponent,
        canDeactivate: [ConfirmDeactivateGuard],
      },
      {
        path: 'editor',
        component: EditorComponent,
        canDeactivate: [ConfirmDeactivateGuard],
      },
      {
        path: 'editor/point/:pointID/:typeRTF',
        component: EditorComponent,
        canDeactivate: [ConfirmDeactivateGuard],
      },
      {
        path: 'editor/point3P/:pointID3P/:fileType',
        component: EditorComponent,
        canDeactivate: [ConfirmDeactivateGuard],
      },
      {
        path: 'editor/meeting/:meetingID/:type',
        component: IntroConclusionPointComponent,
      },
      {
        path: 'editor/documentmodel/:modeleID',
        component: EditorComponent,
        canDeactivate: [ConfirmDeactivateGuard],
      },
      {
        path: 'editor/documentmodel/:modeleID/seanceId/:seanceId',
        component: EditorComponent,
        canDeactivate: [ConfirmDeactivateGuard],
      },
      {
        path: 'editor/documentmodel/:modeleID/pointId/:pointId',
        component: EditorComponent,
        canDeactivate: [ConfirmDeactivateGuard],
      },
      {
        path: 'assistance',
        component: AssistanceComponent,
      },
      {
        path: 'actions',
        loadChildren: () => import('./modules/private/pages/actions/actions.module').then((m) => m.ActionsModule),
        title: 'Actions',
      },
      {
        path: 'iscan',
        component: HomeScanComponent,
        canDeactivate: [ConfirmDeactivateScanGuard],
      },
      {
        path: 'iscan/detail/:id',
        component: DetailScanComponent,
        canDeactivate: [ConfirmDeactivateScanGuard],
      },
      {
        path: 'reports',
        loadChildren: () => import('./modules/private/pages/reports/reports.module').then((m) => m.ReportsModule),
        title: 'Rapports',
      },
      {
        path: 'contacts',
        loadChildren: () => import('./modules/private/pages/contacts/contacts.module').then((m) => m.ContactsModule),
        title: 'Contacts',
      },
    ],
  },
  {
    path: `dev`,
    component: DevComponent,
    canActivate: [devGuard],
  },
  {
    path: '**',
    redirectTo: 'public',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
